import { createAsyncThunk, createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';

import { getSmurTeams } from '../utils/backendApi/geolocation';

const REDUCER_NAME = 'smurTeam';
const smurTeamAdapter = createEntityAdapter({
  selectId: (smurTeam) => smurTeam.station.id,
});

const initialState = {
  ...smurTeamAdapter.getInitialState(),
  error: null,
};

export const listSmurTeams = createAsyncThunk(`${REDUCER_NAME}/list`, async() => {
  const locationData = await getSmurTeams();
  return {
    smurTeams: locationData.locations,
    googleMapsAPIKey: locationData.google_maps_api_key,
  };
});


const smurTeamSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    updateOnesmurTeam(state, payload) {
      smurTeamAdapter.updateOne(state, { id: payload.smurTeam.id, changes: { ...payload.smurTeam } });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listSmurTeams.fulfilled, (state, { payload }) => {
      smurTeamAdapter.upsertMany(state, payload.smurTeams);
    });
    builder.addMatcher((action) => [listSmurTeams.rejected.toString()].includes(action.type), (state, { error }) => {
      state.error = error;
    });
  },
});

export const {
  selectById: selectsmurTeamById,
  selectAll: selectAllSmurTeams,
} = smurTeamAdapter.getSelectors((state) => state.smurTeam);

export const selectAllAvailablesmurTeam = createSelector(
  selectAllSmurTeams,
  (smurTeam) => smurTeam.filter(({ currentIntervention }) => !currentIntervention));
export const selectNearestAvailablesmurTeam = createSelector(
  selectAllAvailablesmurTeam,
  (smurTeam, interventionLocation) => smurTeam.reduce((nearestSmurTeam, currentsmurTeam) => {
  // TO IMPLEMENT: use google.maps.geometry.spherical.computeDistance() to compare distance between points, if distance returned is lower than current distance, nearestFacility is set to currentFacility
    return smurTeam[0];
  }, smurTeam[0]));

export const {
  updateOnesmurTeam,
} = smurTeamSlice.actions;
export default smurTeamSlice.reducer;
